import React from 'react'
import GlobalStyles from './GlobalStyles'
import { Route, Routes } from 'react-router-dom'
import Home from './pages/Home/Home'
import Calculator from './pages/Calculator/Calculator'
import Navbar from './components/Navbar/Navbar'

const App = () => {
  return (
    <>
      <GlobalStyles />
      <Navbar />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/calculator/:name" element={<Calculator />} />
      </Routes>
    </>
  )
}

export default App
